import Hunt from './components/hunt';
import './App.css';

function App() {
  return (
    <div className="App">
      <Hunt />
    </div>
  );
}

export default App;
